import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import { isEmpty } from 'lodash/lang';

import {
  scBrown100,
  scDarkRed100,
  scDarkTeal100,
  scPink20,
  scRed30,
  scTeal20,
  scTeal30,
  scYellow30,
  scYellow50
} from '../../../../../../constants/systemColors';
import { getCurrentRouteByLocation } from '../../../../router/service';

import {
  HIGH_PRIORITY,
  HIGH_PRIORITY_LABEL,
  LOW_PRIORITY,
  LOW_PRIORITY_LABEL,
  MEDIUM_PRIORITY,
  MEDIUM_PRIORITY_LABEL,
  OTHER,
  OTHER_TRAVEL_TASK
} from './taskConstants';

const validationKeys = ['topic', 'topicTitle', 'dueDate', 'assigneeDto', 'studyId', 'siteId'];

export const defaultFieldsValidation = {};

validationKeys.forEach(value => {
  defaultFieldsValidation[value] = true;
});

export function validateTask(task, setTaskFormValidationMap) {
  if ([OTHER, OTHER_TRAVEL_TASK].includes(task.topic) && task.topicTitle?.length > 30) {
    return false;
  }
  const fieldsValidation = doValidationKeys(task);
  setTaskFormValidationMap(fieldsValidation);
  return Object.values(fieldsValidation).indexOf(false) < 0 && isEmpty(fieldsValidation.taskLinks);
}

function doValidationKeys(task) {
  const fieldsValidation = {};
  validationKeys.forEach(valueKey => {
    if (valueKey === 'assigneeDto') {
      fieldsValidation[valueKey] = !isEmpty(task[valueKey].personnelIds);
    } else if (valueKey === 'topicTitle') {
      if ([OTHER, OTHER_TRAVEL_TASK].includes(task.topic)) {
        fieldsValidation[valueKey] = Boolean(task[valueKey]);
      }
    } else {
      fieldsValidation[valueKey] = Boolean(task[valueKey]);
    }
  });
  fieldsValidation.taskLinks = [];
  if (!isEmpty(task.taskLinks)) {
    task.taskLinks
      .filter(e => !e.removed && e.externalLink)
      .forEach(link => {
        const isInvalidLink = !isEmpty(link.link) && !validateLink(link.link);
        if (isInvalidLink || isEmpty(link.link) || isEmpty(link.linkComment)) {
          fieldsValidation.taskLinks = [...fieldsValidation.taskLinks, link.id];
        }
      });
  }
  return fieldsValidation;
}

function validateLink(url) {
  const regex = new RegExp('https?://');
  return regex.test(url);
}

export function getTopicNameValidationMessage(topicTitle, isTopicTitlePresent) {
  if (topicTitle?.length > 30) {
    return 'Topic Name must be maximum 30 characters';
  }
  if (!isTopicTitlePresent) {
    return 'Topic Name is required';
  }
  return '';
}

export function toIdWithName(collection) {
  return collection.map((e, idx) => ({ name: e, id: idx }));
}

export function getRouteByPathname(pathname) {
  return getCurrentRouteByLocation({ pathname });
}

export function resolveTaskPriorityParams(priority) {
  switch (priority) {
    case HIGH_PRIORITY:
      return {
        backgroundColor: scPink20,
        TaskIcon: ArrowUpwardIcon,
        color: scDarkRed100,
        activeColor: scRed30,
        label: HIGH_PRIORITY_LABEL
      };
    case MEDIUM_PRIORITY:
      return {
        backgroundColor: scYellow30,
        TaskIcon: HorizontalRuleIcon,
        color: scBrown100,
        activeColor: scYellow50,
        label: MEDIUM_PRIORITY_LABEL
      };
    case LOW_PRIORITY:
      return {
        backgroundColor: scTeal20,
        TaskIcon: ArrowDownwardIcon,
        color: scDarkTeal100,
        activeColor: scTeal30,
        label: LOW_PRIORITY_LABEL
      };
    default:
      return null;
  }
}
